import { Controller } from "@hotwired/stimulus"

/**
 * PasswordToggleController
 * 
 * Toggles password field visibility between hidden (dots) and visible (text)
 * with eye/eye-off icon switching.
 */
export default class extends Controller {
  static targets = ["input", "button", "eyeIcon", "eyeOffIcon"]

  toggle() {
    const isPassword = this.inputTarget.type === "password"
    
    // Toggle input type
    this.inputTarget.type = isPassword ? "text" : "password"
    
    // Toggle icons
    this.eyeIconTarget.classList.toggle("hidden", isPassword)
    this.eyeOffIconTarget.classList.toggle("hidden", !isPassword)
    
    // Update button title
    this.buttonTarget.title = isPassword ? "Ocultar" : "Mostrar"
  }
}
